import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { FormTextField } from './FormTextField';

const keyPrefix = 'components.form-inputs.PasswordField';

type Props = {
  label?: string;
  maxLength: number;
  name: string;
};

/**
 * Campo de contraseña con alternancia para verla. Con una política de hasta
 * doce caracteres y reglas de mayúscula y carácter especial, escribir a ciegas
 * hace que un error de tecleo se descubra hasta el mensaje de confirmación.
 *
 * La alternancia vive aquí y no en cada formulario para que el estado sea de
 * cada campo, y para que todos los formularios la hereden igual.
 */
export const PasswordField: FC<Props> = ({
  label,
  maxLength,
  name,
}): JSX.Element => {
  const { t } = useTranslation('translation', { keyPrefix });
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const toggle = (): void => setIsVisible(visible => !visible);

  return (
    <FormTextField
      name={name}
      label={label}
      type={isVisible ? 'text' : 'password'}
      onlyPasswordChars
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label={isVisible ? t('hide') : t('show')}
              onClick={toggle}
              edge='end'
            >
              {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
